export default function (...args) {
  const array = args[0];
  const object = args[1];

  return (array || []).includes(object);
}
